import { render, staticRenderFns } from "./AppSearchDropdown.vue?vue&type=template&id=a83e7456&scoped=true&"
import script from "./AppSearchDropdown.vue?vue&type=script&setup=true&lang=js&"
export * from "./AppSearchDropdown.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AppSearchDropdown.vue?vue&type=style&index=0&id=a83e7456&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83e7456",
  null
  
)

export default component.exports